import React from "react";
import "./BDtheque.css";

const BDtheque = () => {
  return (
    <div className="BDtheque">
      <h1>BDtheque</h1>
      <div className="BDthequeContent">
        <iframe
          src="https://www.bdphile.fr/user/crapstur/series/"
          title="BDtheque"
        />
      </div>
    </div>
  );
};

export default BDtheque;
